import {onBeforeUnmount, ref} from '@vue/composition-api'

/**
 * Returns a function to `setInterval` with cleanup on component unmount.
 */
export default function useIntervals () {
  const handle = ref()

  onBeforeUnmount(() => {
    if (handle.value) clearInterval(handle.value)
  })

  return set

  function set (handler, interval) {
    handle.value = setInterval(handler, interval)
    return handle.value
  }
}
